import { UserState } from '@/composition/users'
import { GoLiveStatus } from '@/models/Posts'
import { Component } from 'vue'

export enum LiveState {
  SCHEDULED = 'scheduled',
  LIVE = 'live',
  DISCONNECTED = 'disconnected',
  COMPLETED = 'completed',
}

export enum LiveStreamType {
  STREAM = 'stream',
  ROOM = 'room',
}

export enum VideoSource {
  STREAMING_SOFTWARE = LiveStreamType.STREAM,
  ROOM = LiveStreamType.ROOM,
}

export const getAttendeeId = (licenseId: string, type?: string): string => {
  return UserState.state.currentUser?.contactId + '_' + licenseId + '_' + type
}

export enum ActionButtonId {
  AUDIO_BUTTON = 'audio-button',
  VIDEO_BUTTON = 'video-button',
  PARTICIPANTS_BUTTON = 'participants-button',
  CHAT_BUTTON = 'chat-button',
  REACT_BUTTON = 'react-button',
  SHARE_BUTTON = 'share-button',
  RAISE_HAND_BUTTON = 'raise-hand-button',
  SETTINGS_BUTTON = 'settings-button',
  FLIP_CAMERA = 'flip-camera',
}

export type ActionButton = {
  id: ActionButtonId
  label: string
  icon: Component
  isActive: boolean
  key?: string // to check the active state of the button give the key of the control bar ref
  iconOff?: Component
  ref?: HTMLElement
  hideOnMobile?: boolean
  hideOnDesktop?: boolean
}
export const saveObjectToLocalStorage = (
  key: string,
  value: {
    licenseId: string
    sourceEntityId: string
    serverUrl: string
    token: string
  }
): void => {
  try {
    localStorage.setItem(key, JSON.stringify(value))
  } catch (e) {
    console.error('Failed to save to localStorage', e)
  }
}

export interface LiveMessageSentType {
  id: string
  senderAvatar: string
  senderIdentity: string
  senderIdentityType: string | undefined
  senderName: string
  senderRole: string
  text: string
  timestamp: number
  attachment?: {
    id: string
    name: string
    size: number
    type: string
    url: string
  }
  attachments?: Array<{
    id: string
    name: string
    size: number
    type: string
    url: string
  }>
}

export interface LiveMessageReceivedType {
  id: string
  isOwn: boolean
  senderAvatar: string
  senderIdentity: string
  senderIdentityType: string | undefined
  senderName: string
  senderRole: string
  text: string
}

export const getLiveText = (
  status: GoLiveStatus,
  type: LiveStreamType
): string => {
  if (
    [GoLiveStatus.RECORDING_AVAILABLE, GoLiveStatus.STREAM_COMPLETED].includes(
      status as GoLiveStatus
    )
  ) {
    return 'golive.wasLive'
  }
  if (status === GoLiveStatus.STREAM_STARTED || type === LiveStreamType.ROOM) {
    return 'golive.isLive'
  }

  return 'golive.goingLive'
}
